import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Novo Comunicado", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Titulo Comunicado", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "URL", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, " É um card?", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, " Se é card, vai ficar fixo no TOPO?", -1)
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Image", -1)
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Savar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploadcp = _resolveComponent("ImageUploadcp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.note) = $event)),
          class: "form-control",
          name: "note"
        }, null, 512), [
          [_vModelText, $setup.data.note]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.url) = $event)),
          class: "form-control",
          name: "url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.url]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.iscard) = $event)),
          class: "form-check-input",
          type: "checkbox",
          value: `${$setup.data.iscard}`,
          id: "flexCheckDefault",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkiscard($setup.data.iscard)))
        }, null, 8, _hoisted_12), [
          [_vModelCheckbox, $setup.data.iscard]
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.iscardtop) = $event)),
          class: "form-check-input",
          type: "checkbox",
          value: `${$setup.data.iscardtop}`,
          id: "flexCheckDefault",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkiscardtop($setup.data.iscardtop)))
        }, null, 8, _hoisted_15), [
          [_vModelCheckbox, $setup.data.iscardtop]
        ]),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.image) = $event)),
            class: "form-control",
            name: "image",
            required: ""
          }, null, 512), [
            [_vModelText, $setup.data.image]
          ]),
          _createVNode(_component_ImageUploadcp, {
            tipo: 3,
            onUploaded: _cache[9] || (_cache[9] = ($event: any) => ($setup.data.image = $event))
          })
        ])
      ]),
      _hoisted_20
    ], 32)
  ]))
}